import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const spreads = [
    { name: 'Three-Card Spread', slug: 'three-card-spread' },
    { name: 'Celtic Cross', slug: 'celtic-cross' },
    { name: 'One-Card Draw', slug: 'one-card-draw' },
    { name: 'Relationship Spread', slug: 'relationship-spread' },
    { name: 'Career Path Spread', slug: 'career-path-spread' },
    { name: 'Decision Making Spread', slug: 'decision-making-spread' },
    { name: 'Year Ahead Spread', slug: 'year-ahead-spread' },
  ];

  return (
    <header className="sticky top-0 z-30 border-b border-purple-500/20 bg-indigo-950/90 backdrop-blur-xl">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/" className="flex items-center gap-2 group">
              <span className="text-2xl group-hover:scale-110 transition-transform">🔮</span>
              <span className="text-xl font-heading font-bold bg-gradient-to-r from-amber-200 to-purple-300 bg-clip-text text-transparent">
                Tarot Reader AI
              </span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <a href="/" className="text-purple-100 hover:text-amber-300 transition-colors font-medium">
              Home
            </a>

            {/* Spreads Dropdown */}
            <div className="relative group">
              <button className="text-purple-100 hover:text-amber-300 transition-colors font-medium flex items-center gap-1">
                Tarot Spreads
                <span className="text-xs">▼</span>
              </button>
              <div className="absolute top-full left-0 mt-2 w-64 bg-gradient-to-br from-purple-900/95 to-indigo-900/95 backdrop-blur-xl border border-purple-400/30 rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="py-2">
                  {spreads.map((spread) => (
                    <a
                      key={spread.slug}
                      href={`/readings/${spread.slug}`}
                      className="block px-4 py-2 text-purple-100 hover:text-amber-300 hover:bg-purple-800/30 transition-colors"
                    >
                      {spread.name}
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <a href="/cards" className="text-purple-100 hover:text-amber-300 transition-colors font-medium">
              Tarot Cards
            </a>
            <a href="https://blog.tarot-reader.ai/" className="text-purple-100 hover:text-amber-300 transition-colors font-medium">
              Blog
            </a>
            <a href="/about" className="text-purple-100 hover:text-amber-300 transition-colors font-medium">
              About
            </a>
            <a href="/how-it-works" className="text-purple-100 hover:text-amber-300 transition-colors font-medium">
              How It Works
            </a>
            <a href="/faq" className="text-purple-100 hover:text-amber-300 transition-colors font-medium">
              FAQ
            </a>
            <a href="/chat" className="text-purple-100 hover:text-amber-300 transition-colors font-medium">
              Chat
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-purple-100 hover:text-amber-300 transition-colors"
          >
            {mobileMenuOpen ? (
              <span className="text-2xl">✕</span>
            ) : (
              <span className="text-2xl">☰</span>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="md:hidden border-t border-purple-500/20 overflow-hidden"
            >
              <div className="py-4 space-y-2">
                <a href="/" className="block px-4 py-2 text-purple-100 hover:text-amber-300 transition-colors">
                  Home
                </a>

                <div className="px-4 py-2">
                  <div className="text-amber-200 font-semibold mb-2">Tarot Spreads</div>
                  <div className="pl-4 space-y-2">
                    {spreads.map((spread) => (
                      <a
                        key={spread.slug}
                        href={`/readings/${spread.slug}`}
                        className="block py-1 text-purple-100 hover:text-amber-300 transition-colors text-sm"
                      >
                        {spread.name}
                      </a>
                    ))}
                  </div>
                </div>

                <a href="/cards" className="block px-4 py-2 text-purple-100 hover:text-amber-300 transition-colors">
                  Tarot Cards
                </a>
                <a href="https://blog.tarot-reader.ai/" className="block px-4 py-2 text-purple-100 hover:text-amber-300 transition-colors">
                  Blog
                </a>
                <a href="/about" className="block px-4 py-2 text-purple-100 hover:text-amber-300 transition-colors">
                  About
                </a>
                <a href="/how-it-works" className="block px-4 py-2 text-purple-100 hover:text-amber-300 transition-colors">
                  How It Works
                </a>
                <a href="/faq" className="block px-4 py-2 text-purple-100 hover:text-amber-300 transition-colors">
                  FAQ
                </a>
                <a href="/chat" className="block px-4 py-2 text-purple-100 hover:text-amber-300 transition-colors">
                  Chat
                </a>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
    </header>
  );
}
